module.exports = __webpack_public_path__ + "media/131.0368c8f6.wav";